import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getWebShop as getWebShopApi
} from "../../../helpers/backend_helper";

export const getShopMenu = createAsyncThunk("Web/menu/getWebShop", async (params: any) => {
    try {
        const response = await getWebShopApi(params);
        return response;
    } catch (error: any) {
        throw error;
    }
});